import { render, staticRenderFns } from "./StockSlipTransactions.vue?vue&type=template&id=39b9a442"
import script from "./StockSlipTransactions.vue?vue&type=script&lang=js"
export * from "./StockSlipTransactions.vue?vue&type=script&lang=js"
import style0 from "./StockSlipTransactions.vue?vue&type=style&index=0&id=39b9a442&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports